'use strict';

exports.MultiTermQueryBase = require('./multi-term-query-base');

exports.TermQuery = require('./term-query');
exports.TermsQuery = require('./terms-query');
exports.TermsSetQuery = require('./terms-set-query');
exports.RangeQuery = require('./range-query');
exports.ExistsQuery = require('./exists-query');
exports.PrefixQuery = require('./prefix-query');
exports.WildcardQuery = require('./wildcard-query');
exports.RegexpQuery = require('./regexp-query');
exports.FuzzyQuery = require('./fuzzy-query');
exports.TypeQuery = require('./type-query');
exports.IdsQuery = require('./ids-query');
